var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaintenanceLogoCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 369,
    height: 370,
    viewBox: "0 0 369 370",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.447 83.8324L126.998 46.3461L15.9022 92.352L87.5804 133.814C98.9399 112.117 117.797 94.0559 142.447 83.8324Z",
    fill: "#052F66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226.051 83.9465L241.727 46.1195L130.745 0L152.214 80.4251C177.205 72.8142 203.218 74.5181 226.051 83.9465Z",
    fill: "#031B3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0059 127.339L0 238.321L79.9707 216.965C72.1327 191.861 73.8366 165.734 83.3785 142.902L46.0059 127.339Z",
    fill: "#074291"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M285.012 143.016L323.066 127.227L277.174 16.2447L235.371 88.3773C257.067 99.7368 274.902 118.593 285.012 143.016Z",
    fill: "#86B5F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M322.269 242.071L368.389 130.975L288.304 152.217C296.256 177.322 294.552 203.448 284.896 226.395L322.269 241.957V242.071Z",
    fill: "#5C9CEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2674 226.281L45.0995 242.071L90.9918 353.167L132.795 280.92C111.325 269.447 93.3773 250.59 83.2674 226.281Z",
    fill: "#0856BB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M225.825 285.577L241.274 323.063L352.37 277.171L280.691 235.709C269.218 257.519 250.361 275.581 225.825 285.691V285.577Z",
    fill: "#3382EB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M142.336 285.35L126.546 323.291L237.642 369.41L216.172 288.985C191.181 296.823 165.055 294.892 142.336 285.35Z",
    fill: "#0A69E6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceLogoCircle);
export default __webpack_public_path__ + "static/media/maintenance-logo-circle.460d214c153d0796923ff7d23266cc71.svg";
export { ForwardRef as ReactComponent };